var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:none;stroke:#BABABA;stroke-width:2.2389;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2389;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,104.4c-18.7,0-37.8-0.8-55.7-5.7c-17.5-4.9-33.6-14.3-47.9-25.2C96.5,66.4,88,60.8,75.8,61.6 c-11.9,0.6-23.3,5.1-32.5,12.7c-15.5,13.6-13.2,38.7-7,56.3c9.3,26.6,37.7,45.1,61.8,57.1c27.8,13.9,58.4,22,89.1,26.6 c26.9,4.1,61.4,7.1,84.7-10.5c21.4-16.1,27.2-52.9,22-77.8c-1.3-7.3-5.2-14-11-18.7c-15-11-37.4-3.6-54.3-3.3 C222.3,104.3,215.9,104.4,209.5,104.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.7,257.9c45.4,0,82.2-2.3,82.2-5.1c0-2.8-36.8-5.1-82.2-5.1s-82.2,2.3-82.2,5.1 C81.5,255.6,118.3,257.9,163.7,257.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.2,34.6c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2C264,33.6,265,34.6,266.2,34.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.3,16.2c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C118.1,15.2,119,16.2,120.3,16.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,225.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2 C144.6,224.2,145.6,225.1,146.8,225.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.4,5.8v9.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.5,10.6h9.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,46.3v9.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.7,51.1h9.6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.8,180.5v9.6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.9,185.3h9.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.7,81.7v9.6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.9,86.6h9.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.6,25.6L75.2,40.3c-7.3,1-12.4,7.6-11.5,14.9l17.1,130.4c1,7.3,7.6,12.4,14.9,11.5l112.4-14.8 c7.3-1,12.4-7.7,11.5-14.9L202.5,37C201.5,29.8,194.9,24.6,187.6,25.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M220.3,44.7H106.8c-7.4,0-13.3,6-13.3,13.3v131.8c0,7.4,6,13.3,13.3,13.3h113.5c7.4,0,13.3-6,13.3-13.3V58 C233.6,50.7,227.7,44.7,220.3,44.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.4,149l22.7-37c0.2-0.5,0.6-1,1.1-1.3c0.5-0.3,1.1-0.5,1.6-0.5c0.6,0,1.2,0.2,1.6,0.5 c0.5,0.3,0.9,0.8,1.1,1.3l12.9,21c0.2,0.5,0.6,1,1.1,1.3c0.5,0.3,1.1,0.5,1.6,0.5c0.6,0,1.2-0.2,1.6-0.5c0.5-0.3,0.9-0.8,1.1-1.3 l22-35.8c0.2-0.5,0.6-1,1.1-1.3c0.5-0.3,1.1-0.5,1.6-0.5c0.6,0,1.2,0.2,1.6,0.5c0.5,0.3,0.9,0.8,1.1,1.3l32.3,52.7L110.4,149z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.7,107c3.9,0,7.1-3.2,7.1-7.1s-3.2-7.1-7.1-7.1c-3.9,0-7.1,3.2-7.1,7.1S151.8,107,155.7,107z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.eb0abc8e85170b948e21a2310802d25b.svg";
export { ForwardRef as ReactComponent };